/**
 * Odemis UI · páginas
 * Preguntas frecuentes: búsqueda sin tildes y filtro por tema.
 */
(() => {
  'use strict';

  if (customElements.get('od-faq')) return;

  const normalize = (value) =>
    String(value || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[̀-ͯ]/g, '')
      .trim();

  class OdFaq extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.items = [...this.querySelectorAll('[data-od-faq-item]')];
      this.headings = [...this.querySelectorAll('[data-od-faq-heading]')];
      this.cats = [...this.querySelectorAll('[data-od-faq-cat]')];
      this.search = this.querySelector('[data-od-faq-search]');
      this.empty = this.querySelector('[data-od-faq-empty]');
      this.cat = '';
      this.items.forEach((item) => (item.odText = normalize(item.textContent)));

      this.cats.forEach((button) =>
        button.addEventListener('click', () => {
          this.cat = button.dataset.odFaqCat;
          this.cats.forEach((other) => {
            const active = other === button;
            other.classList.toggle('is-active', active);
            other.setAttribute('aria-pressed', String(active));
          });
          this.apply();
        })
      );

      let timer;
      this.search?.addEventListener('input', () => {
        clearTimeout(timer);
        timer = setTimeout(() => this.apply(), 120);
      });

      // En el editor del tema, al elegir una pregunta se abre.
      this.onBlockSelect = (event) => {
        const item = event.target.closest && event.target.closest('[data-od-faq-item]');
        if (item && this.contains(item)) item.open = true;
      };
      document.addEventListener('shopify:block:select', this.onBlockSelect);
    }

    disconnectedCallback() {
      document.removeEventListener('shopify:block:select', this.onBlockSelect);
      this.ready = false;
    }

    apply() {
      const terms = normalize(this.search?.value).split(/\s+/).filter(Boolean);
      const groups = new Set();
      let count = 0;
      this.items.forEach((item) => {
        const show = (!this.cat || item.dataset.odFaqGroup === this.cat) && terms.every((term) => item.odText.includes(term));
        item.hidden = !show;
        if (!show) return;
        count += 1;
        groups.add(item.dataset.odFaqGroup);
        if (terms.length) item.open = true;
      });
      this.headings.forEach((heading) => (heading.hidden = !groups.has(heading.dataset.odFaqHeading)));
      if (this.empty) this.empty.hidden = count > 0;
    }
  }

  customElements.define('od-faq', OdFaq);
})();
